import React from "react";
import {
  Box,
  Button,
  ListItemButton,
  ListItemText,
  Modal,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";

const SelectSessionToCheckInModal = ({ open, event, handleClose }) => {
  const { sessions } = event || {};
  return (
    <Modal open={open}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "100%", sm: "100%", md: 600 },
          bgcolor: "background.paper",
          border: "2px solid #000",
          boxShadow: 24,
          p: 4,
          maxHeight: "90vh",
          overflow: "auto",
        }}
      >
        <Typography variant="h5">Select Session To Check In</Typography>

        <Box sx={{ marginTop: "20px" }}>
          <ListItemButton
            component={Link}
            to={{ hash: "checkIn", query: { sessionId: "" } }}
            onClick={() => {
              handleClose();
            }}
          >
            <ListItemText primary="None (check in for event)" />
          </ListItemButton>
          {(sessions || []).map((session) => {
            const { id, name } = session;
            return (
              <ListItemButton
                component={Link}
                to={{ hash: "checkIn", search: `sessionId=${id}` }}
                key={`session-${id}`}
                onClick={() => {
                  handleClose();
                }}
              >
                <ListItemText primary={name} />
              </ListItemButton>
            );
          })}
        </Box>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            gap: "20px",
            marginTop: "20px",
          }}
        >
          <Button
            color="secondary"
            variant="contained"
            sx={{ flexGrow: 1 }}
            onClick={async () => {
              await handleClose();
            }}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default SelectSessionToCheckInModal;
